<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-1" lang="en-GB"><a id="_idTextAnchor002"></a>Oh Death who are you?</h1>
<p class="Verse-first" lang="en-GB"><em class="italic">Oh you encaged black and white bird</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">Oh you who have taken life away</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You feared by men, feared by all </em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You who said no to tomorrow</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You whom darkness belongs to</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">Oh you powerful one, you friend of nobody</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You unkind to human life, unkind to human body</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You the one that puts end to pain to cause pain</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You older than all others, than life</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">Oh you who will die last</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You whom everyone bows down to </em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">You who invite all to live with you</em></p>
<p class="Verse-main" lang="en-GB"><em class="italic">Oh death who are you?</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB3.vue?318fea79